import { map } from "rxjs";
import { apiService, TAG } from "./ApiService";
import { logW } from "@blacknut/logging/dist";

/**
 * @deprecated
 * @param gameId
 * @returns
 */
export const isGameFavorite = (gameId: string) => {
  logW(TAG, "@deprecated");
  return apiService
    .get<{ isFavorite: boolean }>({
      path: `v1/me/favorites/${gameId}`,
    })
    .pipe(
      map(({ isFavorite }) => {
        return isFavorite;
      }),
    );
};
